import {
  GET_ALL_CODES_FAILURE,
  GET_ALL_CODES_REQUEST,
  GET_ALL_CODES_SUCCESS,
} from "../../actions/actionTypes";

const initialState = {
  loading: false,
  codes: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CODES_REQUEST:
      return {
        codes: [],
        loading: true,
      };
    case GET_ALL_CODES_SUCCESS:
      return {
        loading: false,
        codes: action.payload,
        error: "",
      };
    case GET_ALL_CODES_FAILURE:
      return {
        loading: false,
        codes: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
